import { useParams, Link } from 'react-router-dom';
import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import MovieCard from '@/components/feature/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const movies = getMoviesByCategory(slug || 'dongzuo');

  const catName = currentCategory.name;
  const catDesc = `农民影视${catName}频道，为您精选最新最全的${catName}资源。高清画质、流畅播放，${catName}免费在线观看尽在农民影视。`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${catName} - 农民影视`,
    description: catDesc,
    url: `https://www.nongminyingshi.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '农民影视',
      url: 'https://www.nongminyingshi.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title={`${catName} - 农民影视 | 免费${catName}在线观看`}
        description={catDesc}
        keywords={`${catName},农民影视,免费${catName},${catName}在线观看,高清${catName}`}
        canonicalUrl={`/category/${slug}`}
        ogTitle={`${catName} - 农民影视`}
        ogDescription={catDesc}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100">
          <Breadcrumb />
          <div className="w-full px-4 md:px-6 pb-8">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex items-center gap-3 mb-2">
                <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className={`${currentCategory.icon} text-lg`}></i>
                </span>
                <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  {catName}
                </h1>
                <span className="text-sm text-foreground-500">({movies.length}部)</span>
              </div>
              <p className="text-sm text-foreground-500 ml-[52px]">
                农民影视为您精选{catName}资源，高清免费在线观看
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 pb-6 overflow-x-auto">
          <div className="max-w-[1280px] mx-auto flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:text-foreground-900 hover:bg-background-100 border border-background-200/60'
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-[1280px] mx-auto">
            {movies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {movies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <span className="w-16 h-16 flex items-center justify-center mx-auto rounded-full bg-secondary-100 text-secondary-500 mb-4">
                  <i className="ri-emotion-sad-line text-2xl"></i>
                </span>
                <p className="text-foreground-500">该分类暂无影片内容</p>
                <Link to="/" className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                  <i className="ri-arrow-left-line"></i>
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}